var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":require("../../../../public/img/logo.png"),"alt":"Imagen centrada"}})])
}]

export { render, staticRenderFns }